<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14.16,6.02C14.04,5.66,13.9,5.32,13.73,4.99C13.9,4.7,14,4.36,14,4C14,2.9,13.1,2,12,2C11.64,2,11.3,2.1,11.01,2.27C10.68,2.1,10.34,1.96,9.98,1.84C9.9,0.81,9.05,0,8,0C6.95,0,6.1,0.81,6.02,1.84C5.66,1.96,5.32,2.1,4.99,2.27C4.7,2.1,4.36,2,4,2C2.9,2,2,2.9,2,4C2,4.36,2.1,4.7,2.27,4.99C2.1,5.32,1.96,5.66,1.84,6.02C0.81,6.1,0,6.95,0,8C0,9.05,0.81,9.9,1.84,9.98C1.96,10.34,2.1,10.68,2.27,11.01C2.1,11.3,2,11.64,2,12C2,13.1,2.9,14,4,14C4.36,14,4.7,13.9,4.99,13.73C5.32,13.9,5.66,14.05,6.02,14.16C6.1,15.19,6.95,16,8,16C9.05,16,9.9,15.19,9.98,14.16C10.34,14.04,10.68,13.9,11.01,13.73C11.3,13.9,11.64,14,12,14C13.1,14,14,13.1,14,12C14,11.64,13.9,11.3,13.73,11.01C13.9,10.68,14.04,10.34,14.16,9.98C15.19,9.9,16,9.05,16,8C16,6.95,15.19,6.1,14.16,6.02C14.16,6.02,14.16,6.02,14.16,6.02ZM13.17,9.81C13.12,9.97,13.06,10.12,13,10.27C12.7,10.1,12.36,10,12,10C10.9,10,10,10.9,10,12C10,12.36,10.1,12.7,10.27,13C10.12,13.07,9.97,13.12,9.81,13.17C9.5,12.48,8.81,12,8,12C7.19,12,6.5,12.48,6.19,13.17C6.03,13.11,5.87,13.06,5.73,13C5.9,12.7,6,12.36,6,12C6,10.9,5.1,10,4,10C3.64,10,3.3,10.1,3,10.27C2.93,10.12,2.88,9.97,2.83,9.81C3.52,9.5,4,8.81,4,8C4,7.19,3.52,6.5,2.83,6.19C2.89,6.03,2.94,5.87,3,5.73C3.3,5.9,3.64,6,4,6C5.1,6,6,5.1,6,4C6,3.64,5.9,3.3,5.73,3C5.88,2.93,6.03,2.88,6.19,2.83C6.5,3.52,7.19,4,8,4C8.81,4,9.5,3.52,9.81,2.83C9.97,2.89,10.13,2.94,10.27,3C10.1,3.3,10,3.64,10,4C10,5.1,10.9,6,12,6C12.36,6,12.7,5.9,13,5.73C13.07,5.88,13.12,6.03,13.17,6.19C12.48,6.5,12,7.19,12,8C12,8.81,12.48,9.5,13.17,9.81C13.17,9.81,13.17,9.81,13.17,9.81Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutCircle',
} as DefineComponent
</script>
